export const CHECK_FOR_UPDATE_TOPIC = 'check_for_update_topic'
export const CLOSE_DRAWING_EDITOR_TOPIC = 'close_drawing_editor_topic'
export const OPEN_DRAWING_EDITOR_TOPIC = 'open_drawing_editor_topic'
export const OPEN_PDF_OVERVIEW_TOPIC = 'open_pdf_overview_topic'
export const CLOSE_PDF_OVERVIEW_TOPIC = 'close_pdf_overview_topic'
export const DELETE_CURRENT_REPORT_TOPIC = 'delete_current_report_topic'
export const FORCE_CLOSE_MENU_TOPIC = 'force_close_menu_topic'
export const REPORT_EDITOR_CLOSE_ALL_TABS_TOPIC = 'close_section_topic'
export const REPORT_EDITOR_OPEN_ALL_TABS_TOPIC = 'open_section_topic'
export const DRAWING_MODIFICATION_TOPIC = 'drawing_modification_topic'
export const SAVE_CURRENT_REPORT_TOPIC = 'save_current_report_topic'
export const OPEN_SIGNATURE_MODULE_TOPIC = 'open-signature-module-topic'
export const OPEN_CLOSE_REPORT_SCREEN_TOPIC = 'open-close-report-screen-topic'
export const CLOSE_CLOSE_REPORT_SCREEN_TOPIC = 'close-close-report-screen-topic'
export const CLOSE_SIGNATURE_MODULE_TOPIC = 'close-signature-module-topic'
export const PDF_STEP_COMPLETE_TOPIC = 'pdf-step-complete-topic'
export const NB_REPORTS_SEARCH_RESULT_CHANGED_TOPIC = 'nb-results-changed'
export const NB_ITEMS_SEARCH_RESULT_CHANGED_TOPIC = 'nb-results-changed'
export const DELETE_UNSYNCHRONIZED_MODIFICATIONS_CR_TOPIC = 'delete-unsync-modifications-cr'
export const DUPLICATE_CLOSED_REPORT_TOPIC = 'duplicated-closed-report-topic'

export const SIGNER_UPDATED = 'signer-updated'
export const REMOVE_SIGNER = 'remove-signer'
export const ADD_SIGNER = 'add-signer'

export const COUNTER_SIGNATURE_UPDATED = 'counter_signature_updated'
export const ADD_COUNTER_SIGNATURE = 'add_counter_signature'
export const REMOVE_COUNTER_SIGNATURE = 'remove_counter_signature'

export const COUNTER_SIGNER_UPDATED = 'counter_signer_updated'
export const ADD_COUNTER_SIGNER = 'add_counter_signer'
export const REMOVE_COUNTER_SIGNER = 'remove_counter_signer' 

export const OPEN_COUNTER_SIGNATURE_MODULE_TOPIC = 'open-counter-signature-module-topic'
export const CLOSE_COUNTER_SIGNATURE_MODULE_TOPIC = 'close-counter-signature-module-topic'

export const SIGNATURE_UPDATED = 'signature-updated'

export const SAVE_CONTRE_SIGNED_REPORT = 'save-contre-signed-report'